import React, { Component } from 'react';
import { connect } from 'react-redux';
import ui from 'redux-ui';
import Utils from 'components/Common/Utils';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button/Button';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import TrackedButton from 'components/Common/Inputs/Buttons/TrackedButton';
import ConnectToQuickbooksButton from 'components/Quickbooks/ConnectToQuickbooksButton';
import QuickbooksOnlineAuthApi from 'resources/QuickbooksOnline/Auth/Api';
import { showErrorDialog } from 'components/Common/CommonActions';

export const OPEN_QBO_DIALOG = 'OPEN_QBO_DIALOG';
export const CLOSE_QBO_DIALOG = 'CLOSE_QBO_DIALOG';

const styles = {
  image: {
    width: '100%',
    height: '100%',
  },
};

@ui({
  state: {
    open: false,
  },
  reducer: (state, action) => {
    switch (action.type) {
      case OPEN_QBO_DIALOG:
        return state.set('open', true);
      case CLOSE_QBO_DIALOG:
        return state.set('open', false);
    }
    return state;
  },
})

@connect(
  (state) => ({}),
  (dispatch) => ({
    onClose: () => {
      dispatch({ type: CLOSE_QBO_DIALOG });
    },
    onError: (e) => {
      dispatch(showErrorDialog(Utils.parseErrorMessage(e)))
    }
  }),
)

@withStyles(styles)
export default class QuickbooksConnectDialog extends Component {
  signUpForQbo() {
    this.props.onClose();
    window.location = 'http://www.quickbooksoffer.com/?cid=irp-17855';
  }

  connectQbo() {
    QuickbooksOnlineAuthApi.getAuthUrl()
      .then(({ data: { url } }) => window.location = url)
      .catch((e) => this.props.onError(e));
  }

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.props.ui.open}
        onClose={this.props.onClose}
      >
        <DialogTitle>
          Connect to QuickBooks Online
        </DialogTitle>
        <img
          className={classes.image}
          src="https://static-assets.housecallpro.com/app_store/apps/quickbooks_online/connect.png"
        />
        <DialogContent />
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.props.onClose}
          >
            Cancel
          </Button>
          <TrackedButton
            color="primary"
            onClick={() => this.signUpForQbo()}
            trackingName="create_qb_account"
            data-testid="create-qb-account"
          >
            Sign up for QuickBooks
          </TrackedButton>
          <ConnectToQuickbooksButton onClick={this.connectQbo} />
        </DialogActions>
      </Dialog>
    );
  }
}
